import VectorIcon from '../VectorIcon';

import ReactModal from 'react-modal';
import LoginForm from '../forms/LoginForm.client';

interface LoginModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export default function LoginModal({isOpen, onRequestClose}: LoginModalProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      className="modal__content modal-login-inner default-modal"
      overlayClassName="modal modal_active modal-login"
      shouldCloseOnOverlayClick={true}
      onRequestClose={onRequestClose}
      closeTimeoutMS={300}
    >
      <div
        role="button"
        tabIndex={-1}
        className="default-modal__close js-modal-close"
        onClick={() => onRequestClose()}
      >
        <VectorIcon iconName="delete-x" />
      </div>
      <div className="default-modal__box" id="modal-login-content">
        <LoginForm />
      </div>
    </ReactModal>
  );
}
